var chunkMapping = {
	"95": [
		30095
	],
	"116": [
		70116
	],
	"282": [
		20282
	],
	"288": [
		80288
	],
	"882": [
		50882
	],
	"900": [
		40900
	],
	"1363": [
		71363
	],
	"1692": [
		31692
	],
	"1758": [
		81758
	],
	"1774": [
		61774
	],
	"2035": [
		62035
	],
	"2119": [
		12119
	],
	"2254": [
		2254
	],
	"2269": [
		52269
	],
	"2286": [
		82286
	],
	"2428": [
		62428
	],
	"2560": [
		32560
	],
	"2764": [
		72764
	],
	"2769": [
		62769
	],
	"2812": [
		72812
	],
	"2838": [
		82838
	],
	"2870": [
		62870
	],
	"2934": [
		2934
	],
	"3033": [
		93033
	],
	"3138": [
		63138
	],
	"3372": [
		43372
	],
	"3460": [
		93460
	],
	"3597": [
		23597
	],
	"3616": [
		23616
	],
	"3718": [
		63718
	],
	"3775": [
		3775
	],
	"3785": [
		93785
	],
	"3921": [
		13921
	],
	"4056": [
		44056
	],
	"4065": [
		56446
	],
	"4072": [
		64072
	],
	"4365": [
		4365
	],
	"4432": [
		44432
	],
	"4470": [
		74470
	],
	"5002": [
		75002
	],
	"5032": [
		5032
	],
	"5283": [
		55283
	],
	"5378": [
		75378
	],
	"5408": [
		25408
	],
	"5416": [
		95416
	],
	"5473": [
		55473
	],
	"5523": [
		45523
	],
	"5540": [
		15540
	],
	"5854": [
		95854
	],
	"5899": [
		5899
	],
	"6016": [
		96016
	],
	"6209": [
		26209
	],
	"6298": [
		66298
	],
	"6393": [
		46393
	],
	"6514": [
		26514
	],
	"6739": [
		86739
	],
	"6880": [
		66880
	],
	"7210": [
		27210
	],
	"7367": [
		77367
	],
	"7512": [
		15131
	],
	"7586": [
		77586
	],
	"7647": [
		77647
	],
	"7706": [
		7706
	],
	"7721": [
		47721
	],
	"7904": [
		87904
	],
	"8047": [
		78047
	],
	"8216": [
		38216
	],
	"8273": [
		88273
	],
	"8358": [
		98358
	],
	"8386": [
		48386
	],
	"8629": [
		38629
	],
	"8773": [
		18773
	],
	"9414": [
		99414
	],
	"9496": [
		39496
	],
	"9597": [
		99597
	],
	"9643": [
		39643
	],
	"9948": [
		29948
	]
};
var idToExternalAndNameMapping = {
	"2254": [
		"default",
		"./OrderEntryCartPage",
		6929
	],
	"2934": [
		"default",
		"./CataloguePage",
		51438
	],
	"3775": [
		"default",
		"./AddressSelectionPage",
		22722
	],
	"4365": [
		"default",
		"./ChangeEmailFailedMessagePage",
		22722
	],
	"5032": [
		"default",
		"./BasicSetup",
		6929
	],
	"5899": [
		"default",
		"./Navbar",
		4019
	],
	"7706": [
		"default",
		"./OrderHistoryDetailRedirectPage",
		22722
	],
	"12119": [
		"default",
		"./CustomerRestrictionsPage",
		98571
	],
	"13921": [
		"default",
		"./OrderHistoryPage",
		22722
	],
	"15131": [
		"default",
		"./ABExperimentsPage",
		37705
	],
	"15540": [
		"default",
		"./AbandonedCartPage",
		6929
	],
	"18773": [
		"default",
		"./ShoppingListPage",
		22722
	],
	"20282": [
		"default",
		"./CustomerCartPage",
		6929
	],
	"23597": [
		"default",
		"./SupportToolPage",
		6929
	],
	"23616": [
		"default",
		"./EmployeeArticleFetcher",
		22186
	],
	"25408": [
		"default",
		"./PaymentPage",
		6929
	],
	"26209": [
		"default",
		"./HistoryListPage",
		22722
	],
	"26514": [
		"default",
		"./CustomerSearchPage",
		98571
	],
	"27210": [
		"default",
		"./PrivacyStatementPage",
		51438
	],
	"29948": [
		"default",
		"./EditAddress",
		22722
	],
	"30095": [
		"default",
		"./CategoryConfigurationPage",
		73610
	],
	"31692": [
		"default",
		"./OrderEntrySearchPage",
		6929
	],
	"32560": [
		"default",
		"./ListOverviewPage",
		22722
	],
	"38216": [
		"default",
		"./TermsPage",
		51438
	],
	"38629": [
		"default",
		"./SelectAddressHook",
		22722
	],
	"39496": [
		"default",
		"./FailedSubmitsPage",
		6929
	],
	"39643": [
		"default",
		"./StoreListOverviewPage",
		22722
	],
	"40900": [
		"default",
		"./ArticleFetcher",
		22186
	],
	"43372": [
		"default",
		"./SubmitMessagePage",
		22722
	],
	"44056": [
		"default",
		"./SearchPage",
		78460
	],
	"44432": [
		"default",
		"./AccountSelectionPage",
		22722
	],
	"45523": [
		"default",
		"./ChangeEmailSuccessMessagePage",
		22722
	],
	"46393": [
		"default",
		"./FAQPage",
		51438
	],
	"47721": [
		"default",
		"./CategoryImagesChoosingPage",
		73610
	],
	"48386": [
		"default",
		"./AiOrderSummaryPage",
		6929
	],
	"50882": [
		"default",
		"./ChangeEmailForm",
		22722
	],
	"52269": [
		"default",
		"./CustomerInformations",
		22722
	],
	"55283": [
		"default",
		"./CreativesManagementPage",
		37705
	],
	"55473": [
		"default",
		"./CampaignManagementPage",
		37705
	],
	"56446": [
		"default",
		"./LoyaltypointsPage",
		22722
	],
	"61774": [
		"default",
		"./MyCMRStatements",
		22722
	],
	"62035": [
		"default",
		"./AddAddress",
		22722
	],
	"62428": [
		"default",
		"./CategoryPage",
		78460
	],
	"62769": [
		"default",
		"./SavedCartPage",
		6929
	],
	"62870": [
		"default",
		"./AddAddressPageWithRedirect",
		22722
	],
	"63138": [
		"default",
		"./CheckoutInitPage",
		6929
	],
	"63718": [
		"default",
		"./SynonymsManagementPage",
		73610
	],
	"64072": [
		"default",
		"./AddressList",
		22722
	],
	"66298": [
		"default",
		"./LegalNoticePage",
		51438
	],
	"66880": [
		"default",
		"./ReorderPage",
		22722
	],
	"70116": [
		"default",
		"./SynonymEditingPage",
		73610
	],
	"71363": [
		"default",
		"./MetroXBrandBar",
		22722
	],
	"72764": [
		"default",
		"./DeliveryPage",
		6929
	],
	"72812": [
		"default",
		"./AnonCartPage",
		6929
	],
	"74470": [
		"default",
		"./CartPdfPage",
		6929
	],
	"75002": [
		"default",
		"./StoreListPageWrappers",
		51438
	],
	"75378": [
		"default",
		"./SavedCartsListPage",
		6929
	],
	"77367": [
		"default",
		"./ChangeEmailConfirmation",
		22722
	],
	"77586": [
		"default",
		"./StoreActivationPage",
		73610
	],
	"77647": [
		"default",
		"./CustomerPortalPage",
		22722
	],
	"78047": [
		"default",
		"./AnonCartDebugPage",
		6929
	],
	"80288": [
		"default",
		"./AiOrdersOverviewPage",
		6929
	],
	"81758": [
		"default",
		"./SummaryPage",
		6929
	],
	"82286": [
		"default",
		"./StoreListManagementPage",
		37705
	],
	"82838": [
		"default",
		"./OrderHistoryDetailPage",
		22722
	],
	"86739": [
		"default",
		"./MyCompany",
		22722
	],
	"87904": [
		"default",
		"./LandingPage",
		22722
	],
	"88273": [
		"default",
		"./OrderHistoryParkingPage",
		22722
	],
	"93033": [
		"default",
		"./OrderConfirmationPage",
		6929
	],
	"93460": [
		"default",
		"./PaymentsPage",
		22722
	],
	"93785": [
		"default",
		"./UidispatcherApiModule",
		56190
	],
	"95416": [
		"default",
		"./PersonallistsCsvUploadPage",
		98571
	],
	"95854": [
		"default",
		"./OrderEntryNewCartPage",
		6929
	],
	"96016": [
		"default",
		"./DeliveryAddressList",
		22722
	],
	"98358": [
		"default",
		"./SearchComparisonPage",
		73610
	],
	"99414": [
		"default",
		"./PromotionsPage",
		78460
	],
	"99597": [
		"default",
		"./IdamCompatibleLogoutLink",
		51438
	]
};
var idToRemoteMap = {
	"2254": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"2934": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	],
	"3775": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"4365": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"5032": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"5899": [
		{
			"externalType": "script",
			"name": "betty_navbar"
		}
	],
	"7706": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"12119": [
		{
			"externalType": "script",
			"name": "ca_backoffice_ui"
		}
	],
	"13921": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"15131": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration"
		}
	],
	"15540": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"18773": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"20282": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"23597": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"23616": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui"
		}
	],
	"25408": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"26209": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"26514": [
		{
			"externalType": "script",
			"name": "ca_backoffice_ui"
		}
	],
	"27210": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	],
	"29948": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"30095": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui"
		}
	],
	"31692": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"32560": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"38216": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	],
	"38629": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"39496": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"39643": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"40900": [
		{
			"externalType": "script",
			"name": "sd_pdp_ui"
		}
	],
	"43372": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"44056": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui"
		}
	],
	"44432": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"45523": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"46393": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	],
	"47721": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui"
		}
	],
	"48386": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"50882": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"52269": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"55283": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration"
		}
	],
	"55473": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration"
		}
	],
	"56446": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"61774": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"62035": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"62428": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui"
		}
	],
	"62769": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"62870": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"63138": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"63718": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui"
		}
	],
	"64072": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"66298": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	],
	"66880": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"70116": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui"
		}
	],
	"71363": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"72764": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"72812": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"74470": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"75002": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	],
	"75378": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"77367": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"77586": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui"
		}
	],
	"77647": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"78047": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"80288": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"81758": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"82286": [
		{
			"externalType": "script",
			"name": "cia_backoffice_inspiration"
		}
	],
	"82838": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"86739": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"87904": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"88273": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"93033": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"93460": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"93785": [
		{
			"externalType": "script",
			"name": "uidispatcher_api"
		}
	],
	"95416": [
		{
			"externalType": "script",
			"name": "ca_backoffice_ui"
		}
	],
	"95854": [
		{
			"externalType": "script",
			"name": "oc_ui"
		}
	],
	"96016": [
		{
			"externalType": "script",
			"name": "cia_explore_ui"
		}
	],
	"98358": [
		{
			"externalType": "script",
			"name": "sd_backoffice_ui"
		}
	],
	"99414": [
		{
			"externalType": "script",
			"name": "sd_articlesearch_ui"
		}
	],
	"99597": [
		{
			"externalType": "script",
			"name": "cia_inspiration_ui"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"2254": {
		"shareScope": "default",
		"name": "./OrderEntryCartPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"2934": {
		"shareScope": "default",
		"name": "./CataloguePage",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	},
	"3775": {
		"shareScope": "default",
		"name": "./AddressSelectionPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"4365": {
		"shareScope": "default",
		"name": "./ChangeEmailFailedMessagePage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"5032": {
		"shareScope": "default",
		"name": "./BasicSetup",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"5899": {
		"shareScope": "default",
		"name": "./Navbar",
		"externalModuleId": 4019,
		"remoteName": "betty_navbar"
	},
	"7706": {
		"shareScope": "default",
		"name": "./OrderHistoryDetailRedirectPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"12119": {
		"shareScope": "default",
		"name": "./CustomerRestrictionsPage",
		"externalModuleId": 98571,
		"remoteName": "ca_backoffice_ui"
	},
	"13921": {
		"shareScope": "default",
		"name": "./OrderHistoryPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"15131": {
		"shareScope": "default",
		"name": "./ABExperimentsPage",
		"externalModuleId": 37705,
		"remoteName": "cia_backoffice_inspiration"
	},
	"15540": {
		"shareScope": "default",
		"name": "./AbandonedCartPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"18773": {
		"shareScope": "default",
		"name": "./ShoppingListPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"20282": {
		"shareScope": "default",
		"name": "./CustomerCartPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"23597": {
		"shareScope": "default",
		"name": "./SupportToolPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"23616": {
		"shareScope": "default",
		"name": "./EmployeeArticleFetcher",
		"externalModuleId": 22186,
		"remoteName": "sd_pdp_ui"
	},
	"25408": {
		"shareScope": "default",
		"name": "./PaymentPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"26209": {
		"shareScope": "default",
		"name": "./HistoryListPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"26514": {
		"shareScope": "default",
		"name": "./CustomerSearchPage",
		"externalModuleId": 98571,
		"remoteName": "ca_backoffice_ui"
	},
	"27210": {
		"shareScope": "default",
		"name": "./PrivacyStatementPage",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	},
	"29948": {
		"shareScope": "default",
		"name": "./EditAddress",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"30095": {
		"shareScope": "default",
		"name": "./CategoryConfigurationPage",
		"externalModuleId": 73610,
		"remoteName": "sd_backoffice_ui"
	},
	"31692": {
		"shareScope": "default",
		"name": "./OrderEntrySearchPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"32560": {
		"shareScope": "default",
		"name": "./ListOverviewPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"38216": {
		"shareScope": "default",
		"name": "./TermsPage",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	},
	"38629": {
		"shareScope": "default",
		"name": "./SelectAddressHook",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"39496": {
		"shareScope": "default",
		"name": "./FailedSubmitsPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"39643": {
		"shareScope": "default",
		"name": "./StoreListOverviewPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"40900": {
		"shareScope": "default",
		"name": "./ArticleFetcher",
		"externalModuleId": 22186,
		"remoteName": "sd_pdp_ui"
	},
	"43372": {
		"shareScope": "default",
		"name": "./SubmitMessagePage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"44056": {
		"shareScope": "default",
		"name": "./SearchPage",
		"externalModuleId": 78460,
		"remoteName": "sd_articlesearch_ui"
	},
	"44432": {
		"shareScope": "default",
		"name": "./AccountSelectionPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"45523": {
		"shareScope": "default",
		"name": "./ChangeEmailSuccessMessagePage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"46393": {
		"shareScope": "default",
		"name": "./FAQPage",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	},
	"47721": {
		"shareScope": "default",
		"name": "./CategoryImagesChoosingPage",
		"externalModuleId": 73610,
		"remoteName": "sd_backoffice_ui"
	},
	"48386": {
		"shareScope": "default",
		"name": "./AiOrderSummaryPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"50882": {
		"shareScope": "default",
		"name": "./ChangeEmailForm",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"52269": {
		"shareScope": "default",
		"name": "./CustomerInformations",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"55283": {
		"shareScope": "default",
		"name": "./CreativesManagementPage",
		"externalModuleId": 37705,
		"remoteName": "cia_backoffice_inspiration"
	},
	"55473": {
		"shareScope": "default",
		"name": "./CampaignManagementPage",
		"externalModuleId": 37705,
		"remoteName": "cia_backoffice_inspiration"
	},
	"56446": {
		"shareScope": "default",
		"name": "./LoyaltypointsPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"61774": {
		"shareScope": "default",
		"name": "./MyCMRStatements",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"62035": {
		"shareScope": "default",
		"name": "./AddAddress",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"62428": {
		"shareScope": "default",
		"name": "./CategoryPage",
		"externalModuleId": 78460,
		"remoteName": "sd_articlesearch_ui"
	},
	"62769": {
		"shareScope": "default",
		"name": "./SavedCartPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"62870": {
		"shareScope": "default",
		"name": "./AddAddressPageWithRedirect",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"63138": {
		"shareScope": "default",
		"name": "./CheckoutInitPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"63718": {
		"shareScope": "default",
		"name": "./SynonymsManagementPage",
		"externalModuleId": 73610,
		"remoteName": "sd_backoffice_ui"
	},
	"64072": {
		"shareScope": "default",
		"name": "./AddressList",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"66298": {
		"shareScope": "default",
		"name": "./LegalNoticePage",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	},
	"66880": {
		"shareScope": "default",
		"name": "./ReorderPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"70116": {
		"shareScope": "default",
		"name": "./SynonymEditingPage",
		"externalModuleId": 73610,
		"remoteName": "sd_backoffice_ui"
	},
	"71363": {
		"shareScope": "default",
		"name": "./MetroXBrandBar",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"72764": {
		"shareScope": "default",
		"name": "./DeliveryPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"72812": {
		"shareScope": "default",
		"name": "./AnonCartPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"74470": {
		"shareScope": "default",
		"name": "./CartPdfPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"75002": {
		"shareScope": "default",
		"name": "./StoreListPageWrappers",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	},
	"75378": {
		"shareScope": "default",
		"name": "./SavedCartsListPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"77367": {
		"shareScope": "default",
		"name": "./ChangeEmailConfirmation",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"77586": {
		"shareScope": "default",
		"name": "./StoreActivationPage",
		"externalModuleId": 73610,
		"remoteName": "sd_backoffice_ui"
	},
	"77647": {
		"shareScope": "default",
		"name": "./CustomerPortalPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"78047": {
		"shareScope": "default",
		"name": "./AnonCartDebugPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"80288": {
		"shareScope": "default",
		"name": "./AiOrdersOverviewPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"81758": {
		"shareScope": "default",
		"name": "./SummaryPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"82286": {
		"shareScope": "default",
		"name": "./StoreListManagementPage",
		"externalModuleId": 37705,
		"remoteName": "cia_backoffice_inspiration"
	},
	"82838": {
		"shareScope": "default",
		"name": "./OrderHistoryDetailPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"86739": {
		"shareScope": "default",
		"name": "./MyCompany",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"87904": {
		"shareScope": "default",
		"name": "./LandingPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"88273": {
		"shareScope": "default",
		"name": "./OrderHistoryParkingPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"93033": {
		"shareScope": "default",
		"name": "./OrderConfirmationPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"93460": {
		"shareScope": "default",
		"name": "./PaymentsPage",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"93785": {
		"shareScope": "default",
		"name": "./UidispatcherApiModule",
		"externalModuleId": 56190,
		"remoteName": "uidispatcher_api"
	},
	"95416": {
		"shareScope": "default",
		"name": "./PersonallistsCsvUploadPage",
		"externalModuleId": 98571,
		"remoteName": "ca_backoffice_ui"
	},
	"95854": {
		"shareScope": "default",
		"name": "./OrderEntryNewCartPage",
		"externalModuleId": 6929,
		"remoteName": "oc_ui"
	},
	"96016": {
		"shareScope": "default",
		"name": "./DeliveryAddressList",
		"externalModuleId": 22722,
		"remoteName": "cia_explore_ui"
	},
	"98358": {
		"shareScope": "default",
		"name": "./SearchComparisonPage",
		"externalModuleId": 73610,
		"remoteName": "sd_backoffice_ui"
	},
	"99414": {
		"shareScope": "default",
		"name": "./PromotionsPage",
		"externalModuleId": 78460,
		"remoteName": "sd_articlesearch_ui"
	},
	"99597": {
		"shareScope": "default",
		"name": "./IdamCompatibleLogoutLink",
		"externalModuleId": 51438,
		"remoteName": "cia_inspiration_ui"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}